import { loadStripe } from '@stripe/stripe-js/pure'
import { Elements } from '@stripe/react-stripe-js'
import { Modal, Grid } from '@mui/material'
import StripeForm from './StripeForm'
import { StripePublicKey } from '../utils/constants'

export type StripeSession = {
  clientSecret: string
  type: 'payment' | 'setup'
  amount: number
}

type Props = {
  setOpen: React.Dispatch<React.SetStateAction<boolean>>
  stripeSession?: StripeSession
  open: boolean
  redirectUrl?: string
}

// Loaded on first open: this module is re-exported by the components barrel, so a
// module-level loadStripe would inject Stripe.js on every page of the funnel.
let stripePromise: ReturnType<typeof loadStripe> | null = null

export default function StripeModal({ stripeSession, open, setOpen, redirectUrl }: Props) {
  if (open) stripePromise ??= loadStripe(StripePublicKey)

  const options = {
    clientSecret: stripeSession?.clientSecret,
    appearance: {},
  }

  return (
    <Modal
      open={open}
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Grid
        container
        item
        xs={12}
        md={6}
        flexDirection="column"
        sx={{
          background: 'white',
          padding: '20px',
        }}
      >
        <Elements stripe={stripePromise} options={options}>
          <StripeForm setOpen={setOpen} redirectUrl={redirectUrl} stripeSession={stripeSession} />
        </Elements>
      </Grid>
    </Modal>
  )
}
